import LocationDetails, { AddressComponent } from '../Models/LocationDetails';

function convertGooglePlaceToLocationDetails(
    place: google.maps.places.PlaceResult,
    onlyRenderCountry: boolean,
): LocationDetails {
    const addressComponents = place.address_components || [];

    const getAddressComponentByType = (type: string): AddressComponent | undefined => {
        for (const component of addressComponents) {
            if (component.types.includes(type)) {
                return { shortName: component.short_name, longName: component.long_name };
            }
        }

        return undefined;
    };

    const city = getAddressComponentByType('locality');
    const administrativeAreaLevel3 = getAddressComponentByType('administrative_area_level_3');
    const administrativeAreaLevel2 = getAddressComponentByType('administrative_area_level_2');
    const administrativeAreaLevel1 = getAddressComponentByType('administrative_area_level_1');
    const country = getAddressComponentByType('country');

    const doRenderState = () => {
        return (country?.shortName === 'US' || country?.shortName === 'CA') && administrativeAreaLevel1;
    };

    const getCityName = () => {
        return city?.longName || administrativeAreaLevel3?.longName; // According to Google manual, if type is (cities), when place should have either locality or administrative_area_level_3 (maybe both)
    };

    // We have to build location description by our-self because we do not support localization
    const getLocationDescription = () => {
        const longName = country?.longName;

        if (onlyRenderCountry) {
            return longName;
        }

        if (doRenderState()) {
            return `${getCityName()}, ${administrativeAreaLevel1?.shortName}, ${longName}`;
        } else {
            return `${getCityName()}, ${longName}`;
        }
    };

    return {
        locationId: place.place_id,
        description: getLocationDescription(),
        geometry: { latitude: place.geometry?.location.lat(), longitude: place.geometry?.location.lng() },
        city,
        administrativeAreaLevel3,
        administrativeAreaLevel2,
        administrativeAreaLevel1,
        country,
        utcOffsetMinutes: place.utc_offset_minutes,
    } as LocationDetails;
}

export default convertGooglePlaceToLocationDetails;
